/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import WyExecutiveReportsPage from '../components/business-insights/wy-executive-reports-page.vue'
import WyPerformanceReportsPage from '../components/business-insights/wy-performance-reports-page.vue'

export default [
  {
    path: '/businessInsights/executiveReports',
    name: 'executiveReports',
    component: WyExecutiveReportsPage,
    meta: { 
        bindModel: 'chat-analytics',
        filterAction: 'fetchChatFilters',
        filterNames: [],
        headerMenuItems: [
          {name:'brands-widget'}
        ]
      }
  },
  {
    path: '/businessInsights/performanceReports',
    name: 'performanceReports',
    component: WyPerformanceReportsPage,
    meta: { 
        bindModel: 'chat-analytics',
        filterAction: 'fetchChatFilters',
        filterNames: [],
        headerMenuItems: [
          {name:'brands-widget'}
        ]
      }
  }
]